"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var createTitle = function createTitle(siteTitle, pageTitle) {
  return "".concat(siteTitle, " | ").concat(pageTitle);
};

var createFacebookMetatags = function createFacebookMetatags(_ref, pageTitle, pageDescription) {
  var baseConfig = _ref.baseConfig,
      socialMediaConfig = _ref.socialMediaConfig;
  return [{
    name: 'fb:app_id',
    content: socialMediaConfig.facebook.appID
  }, {
    name: 'og:type',
    content: socialMediaConfig.facebook.type
  }, {
    name: 'og:url',
    content: socialMediaConfig.facebook.siteUrl
  }, {
    name: 'og:title',
    content: createTitle(baseConfig.siteTitle, pageTitle)
  }, {
    name: 'og:description',
    content: pageDescription
  }, {
    name: 'og:site_name',
    content: baseConfig.siteTitle
  }, {
    name: 'og:image',
    content: socialMediaConfig.facebook.restaurantMetadata.image
  }, {
    name: 'restaurant:contact_info:street_address',
    content: socialMediaConfig.facebook.restaurantMetadata.address
  }, {
    name: 'restaurant:contact_info:locality',
    content: socialMediaConfig.facebook.restaurantMetadata.locality
  }, {
    name: 'restaurant:contact_info:region',
    content: socialMediaConfig.facebook.restaurantMetadata.region
  }, {
    name: 'restaurant:contact_info:postal_code',
    content: socialMediaConfig.facebook.restaurantMetadata.postalCode
  }, {
    name: 'restaurant:contact_info:country_name',
    content: socialMediaConfig.facebook.restaurantMetadata.country
  }, {
    name: 'restaurant:contact_info:email',
    content: socialMediaConfig.facebook.restaurantMetadata.email
  }, {
    name: 'restaurant:contact_info:phone_number',
    content: socialMediaConfig.facebook.restaurantMetadata.phoneNumber
  }, {
    name: 'restaurant:contact_info:website',
    content: baseConfig.siteUrl
  }];
};

var createTwitterMetatags = function createTwitterMetatags(_ref2, pageTitle, pageDescription) {
  var baseConfig = _ref2.baseConfig,
      socialMediaConfig = _ref2.socialMediaConfig;
  return [{
    name: 'twitter:site',
    content: socialMediaConfig.twitter.companyTwitterHandle
  }, {
    name: 'twitter:title',
    content: createTitle(baseConfig.siteTitle, pageTitle)
  }, {
    name: 'twitter:description',
    content: pageDescription
  }, {
    name: 'twitter:creator',
    content: socialMediaConfig.twitter.companyTwitterHandle
  }, {
    name: 'twitter:image',
    content: socialMediaConfig.twitter.image
  }, {
    name: 'twitter:url',
    content: baseConfig.siteUrl
  }];
};

var getMetaTags = function getMetaTags(_ref3) {
  var config = _ref3.config,
      title = _ref3.title,
      description = _ref3.description,
      published = _ref3.published,
      updated = _ref3.updated,
      category = _ref3.category,
      tags = _ref3.tags,
      smTypes = _ref3.smTypes;
  /* Basic SEO metatags */

  var metaTags = [{
    itemprop: 'name',
    content: title
  }, {
    itemprop: 'description',
    content: description
  }, {
    name: 'keywords',
    content: config.baseConfig.keywords
  }, {
    name: 'description',
    content: description
  }];
  /* Integration of facebook object-graph and twitter SEO */

  if (smTypes.includes('facebook')) {
    metaTags = metaTags.concat(createFacebookMetatags(config, title, description));
  }

  if (smTypes.includes('twitter')) {
    metaTags = metaTags.concat(createTwitterMetatags(config, title, description));
  }
  /* Used for publications of articles, blog posts, etc. */


  if (published) {
    metaTags.push({
      name: 'article:published_time',
      content: published
    });
  }

  if (updated) {
    metaTags.push({
      name: 'article:modified_time',
      content: updated
    });
  }

  if (category) metaTags.push({
    name: 'article:section',
    content: category
  });
  if (tags) metaTags.push({
    name: 'article:tag',
    content: tags
  });
  return metaTags.filter(function (metaTag) {
    return metaTag.content;
  });
};

var SEO = function SEO(_ref4) {
  var config = _ref4.config,
      title = _ref4.title,
      description = _ref4.description,
      path = _ref4.path,
      smTypes = _ref4.smTypes,
      published = _ref4.published,
      updated = _ref4.updated,
      category = _ref4.category,
      tags = _ref4.tags;
  return _react["default"].createElement(_reactHelmet["default"], {
    htmlAttributes: {
      lang: 'en',
      itemscope: undefined,
      itemtype: "http://schema.org/".concat(config.baseConfig.schema)
    },
    title: createTitle(config.baseConfig.siteTitle, title),
    link: [{
      rel: 'canonical',
      href: config.baseConfig.siteUrl + path
    }],
    meta: getMetaTags({
      config: config,
      title: title,
      description: description,
      published: published,
      updated: updated,
      category: category,
      tags: tags,
      smTypes: smTypes
    })
  });
};

SEO.propTypes = {
  config: _propTypes["default"].shape({
    baseConfig: _propTypes["default"].object,
    socialMediaConfig: _propTypes["default"].object
  }).isRequired,
  description: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  category: _propTypes["default"].string,
  published: _propTypes["default"].string,
  smTypes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  tags: _propTypes["default"].string,
  updated: _propTypes["default"].string
};
SEO.defaultProps = {
  category: undefined,
  published: undefined,
  smTypes: [],
  tags: undefined,
  updated: undefined
};
var _default = SEO;
exports["default"] = _default;